import React from 'react';

const PRESETS = {
  approved: 'ux-pill-success',
  published: 'ux-pill-success',
  active: 'ux-pill-success',
  completed: 'ux-pill-success',
  pending: 'ux-pill-warning',
  verified: 'ux-pill-success',
  payment_verified: 'ux-pill-success',
  payment_pending: 'ux-pill-warning',
  payment_rejected: 'ux-pill-danger',
  rejected: 'ux-pill-danger',
  draft: 'ux-pill-muted',
  inactive: 'ux-pill-muted',
  beginner: 'ux-pill-success',
  intermediate: 'ux-pill-warning',
  advanced: 'ux-pill-danger',
};

function StatusPill({ status, label, className = '' }) {
  const key = (status || '').toLowerCase().replace(/\s+/g, '_');
  const preset = PRESETS[key] || 'ux-pill-muted';
  const text = label || (status || '').replace(/_/g, ' ');
  return (
    <span className={`ux-pill ${preset} ${className}`.trim()}>
      {text}
    </span>
  );
}

export default StatusPill;
